<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Bizonylat nyomtatása"
      placement="top"
      v-can="'outstandingreport.view'"
      v-if="outstanding.status !== 'recorded' && outstanding.status !== 'cancelled' && outstanding.receipt_file"
    >
      <el-button
        size="mini"
        icon="el-icon-printer"
        style="margin-left: 5px;"
        @click="openReceipt"
      />
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['outstanding'],
    data() {
      return {
        deleteConfirmVisible: false,
      };
    },

    methods: {
      openReceipt() {
        if (this.outstanding.receipt_file && this.outstanding.receipt_file.path) {
          window.open(this.outstanding.receipt_file.path);
        }
      },
    }
  };
</script>
